import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { StudyUnitTopic } from 'src/app/Models/StudyUnitTopic';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VStudyUnit } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {AppOfflineStore} from '../../../app.offlineService';
import { FormControl, Validators } from '@angular/forms';
import { StudyMaterialReportModel } from 'src/app/Models/StudyMaterial';

@Component({
  selector: 'app-content-studyunit-report',
  templateUrl: './content-studyunit-report.component.html',
  styleUrls: ['./content-studyunit-report.component.css']
})
export class ContentStudyunitReportComponent implements OnInit {
  ScreenName1:string;
  lanuage:any;
  MajorTopic:MajorTopic[]=[];
  Studymaterialreport:StudyMaterialReportModel;
  StudyMaterialReportform = new FormGroup({
    SubjectID: new FormControl(''),
    MajorTopicID: new FormControl('')
  })
  constructor(public appser:AppOfflineStore,public Activeroute:ActivatedRoute,private cdr: ChangeDetectorRef,public service:ContentManagementService,private fb: FormBuilder,private toastr: ToastrService) { 
    this.lanuage=this.appser.dataStore[0].Language;
  }

  ngOnInit(): void {
    this.getsubject(null,null);
    //this.getCode();
    this.ScreenName1==this.Activeroute.snapshot.paramMap.get('ScreenName');
  }

  getcodes:any;
  getCode()
  {
    this.service.GetCode({'Tablename':"SUBJECT_LEVEL_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;     
    }, (error:any) => { console.log(error) }
    );
  }
  subject:any;
  getsubject(data:any,d:any){
    let ID:Number=0;
    if(data !=null){ID=Number(data.ID);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'STUDY UNIT';
    list["childRecordStatus"] = 'ALL';
    this.service.getSubjectTree(list).subscribe((i:any)=>{
      this.subject=i;
    // }).catch((e:any)=>{
    //   this.subject=null;
    // }
    // )
  }, error => {  console.log(error) }
  );
  }

  selectedsubject:any;
  ScreenName:any;
  SelectSubject(data:any){
     this.selectedsubject=data.target.value;
     this.StudyMaterialReportform.controls['MajorTopicID'].setValue('');
     this.getreport=null;
     this.getsubjectData(data.target.value,'MT')
     
  }
  getsubjectData(data:any,name:any,M?:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any){


    let ID:Number=0; 
    if(data !=null){ID=Number(data);}
    this.ScreenName=this.Activeroute.snapshot.paramMap.get('ScreenName');
    let list: any = {};
    if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='STUDY UNIT'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY UNIT';
      list["childRecordStatus"] = 'ALL';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='WIP'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'WIP';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Approved'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Approved';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Defer'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Defer';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rejected'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Rejected';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rework'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Rework';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Under Review'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Under Review';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Submitted'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Submitted';
    }
    else{
     
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'ALL';
    }
   
    this.service.getSubjectTree(list).subscribe((i:any)=>{
  
      if(name == 'MT'){
        this.MajorTopic=i;
        console.log(this.MajorTopic,'MajorTopic');
      }
      
    //   }).catch((e:any)=>{
    //   this.subject=null;
    // }
    // )
  }, (error:any) => { console.log(error) }
  );
  }

response:any;
getreport:any;

  Fetchreports(){
    this.Studymaterialreport=this.StudyMaterialReportform.value;
    this.Studymaterialreport.SessionLanguageTypeCode=this.appser.userlanuage;
    this.service.GetStudyUnitReport(this.Studymaterialreport).subscribe((i:any)=>{
      this.response=i;   
      this.getreport=this.response.data; 
      console.log(this.getreport,'getreport') 
    }, (error:any) => { console.log(error) }
    );
  }


}
interface MajorTopic{
  ChildNodeExistInd:string;
  Study_Unit_Ind:string
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id:Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
}
